import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { PromoteCalendarScreen } from './PromoteCalendarScreen';

/** The Promote / Calendar route. Every call is account-scoped. */
const PromoteCalendarViewComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <PromoteCalendarScreen accountId={accountId} />;
};

export const PromoteCalendarView = TypedMemo(PromoteCalendarViewComponent);
